/**
 * Use direct `process.env.UMI_APP_API_URL` access (no optional chaining) so Umi
 * can inline the value at build time. Value is set via define in config/config.ts.
 */
export function normalizeApiBaseUrl(url: string): string {
  let normalized = url.trim();

  // Guard against double-quoted define values (shows up as %22 in request URLs)
  if (
    (normalized.startsWith('"') && normalized.endsWith('"')) ||
    (normalized.startsWith("'") && normalized.endsWith("'"))
  ) {
    normalized = normalized.slice(1, -1).trim();
  }

  normalized = normalized.replace(/\/+$/, '');

  // Endpoints already start with /api/... — strip a trailing /api segment if present
  if (normalized.endsWith('/api')) {
    normalized = normalized.slice(0, -4);
  }

  return normalized;
}

export function getApiBaseUrl(): string {
  const url = process.env.UMI_APP_API_URL;
  if (!url) {
    throw new Error(
      'UMI_APP_API_URL is not set. Copy .env.example to .env.development (for dev) or .env / .env.production (for build) and set your backend URL.',
    );
  }
  return normalizeApiBaseUrl(url);
}
